import type { App } from 'vue'

import { useFueled } from '@/services/fueled'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $fueled: ReturnType<typeof useFueled>
  }
}

export const fueledPlugin = {
  install(app: App) {
    const fueled = useFueled()
    app.config.globalProperties.$fueled = fueled
  }
}

export default fueledPlugin
